export const STORE_OPTION_KEYS = {
  label: 'dealer_name',
  value: 'make_dealer_id'
};
